let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("60orf")).then(() => parcelRequire('3NNqy'));